import ModelLoader from '@components/ModelLoader';
import { ParallaxSection } from '@components/ui/ParallaxSection';
import { MY_PROJECTS, Project } from '@constants/index';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const ProjectIdPage = () => {
  const { id } = useParams();
  const [project, setProject] = useState<Project | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    const project = MY_PROJECTS.find((project) => project.id === parseInt(id as string));
    if (project) {
      setProject(project);
    }
  }, [id]);

  const projectData = [
    {
      title: 'Carrer Impacts',
      impact: project?.career_impacts
    },
    {
      title: project?.title,
      link: project?.link,
      thumbnail: project?.img
    },
    {
      title: 'Tech Stack',
      icons: project?.iconLists
    },
    {
      title: 'My Roles',
      roles: project?.roles
    }
  ];
  return (
    <>
      <ModelLoader className="mt-60 h-[250px] z-10" />
      <ParallaxSection
        className="w-full relative  dark:bg-black-100  bg-white dark:bg-grid-white/[0.3] bg-grid-black/[0.2]"
        data={projectData}
        title={project?.title as string}
        subtitle={project?.des as string}
      />
    </>
  );
};

export default ProjectIdPage;
